"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCurrentBrowserUrl = function (window, document) {
    var isInIframe = window !== window.parent;
    return isInIframe ? document.referrer : document.location.href;
};
exports.isCurrentFrameSDP = function (window) {
    return window.document.URL.includes('/sp/');
};
exports.getNavigator = function () { return navigator; };
/**
 * Mobile and Tablet Detection Mapping
 */
var getMobileOS = {
    isAndroid: function () { return !!exports.getNavigator().userAgent.match(/Android/i); },
    isBlackBerry: function () { return !!(exports.getNavigator().userAgent.match(/BlackBerry/i) ||
        exports.getNavigator().userAgent.match(/PlayBook/i) ||
        exports.getNavigator().userAgent.match(/BB10/i)); },
    isiOS: function () { return !!exports.getNavigator().userAgent.match(/iPhone|iPod/i); },
    isiOS_Tablet: function () { return !!exports.getNavigator().userAgent.match(/iPad/i); },
    isLG: function () { return !!exports.getNavigator().userAgent.match(/webOS/i); },
    isOpera: function () { return !!(exports.getNavigator().userAgent.match(/Opera Mini/i) ||
        exports.getNavigator().userAgent.match(/Opera Mobi/i)); },
    isWindows: function () { return !!(exports.getNavigator().userAgent.match(/IEMobile/i) ||
        exports.getNavigator().userAgent.match(/Windows Phone/i) ||
        exports.getNavigator().userAgent.match(/WPDesktop/i) || // windows phone in desktop mode
        exports.getNavigator().userAgent.match(/Lumia/i)); },
    isUnrecognizedTablet: function () { return !!exports.getNavigator().userAgent.match(/Tablet/i); },
    isUnrecognizedMobile: function () { return !!exports.getNavigator().userAgent.match(/Mobile/i); },
    any: function () { return getMobileOS.isAndroid() ||
        getMobileOS.isBlackBerry() ||
        getMobileOS.isiOS() ||
        getMobileOS.isiOS_Tablet() ||
        getMobileOS.isLG() ||
        getMobileOS.isOpera() ||
        getMobileOS.isWindows() ||
        getMobileOS.isUnrecognizedTablet() ||
        getMobileOS.isUnrecognizedMobile(); }
};
exports.getMobileDeviceOs = function () {
    var deviceHash = {
        Android: getMobileOS.isAndroid(),
        BlackBerry: getMobileOS.isBlackBerry(),
        iPhone: getMobileOS.isiOS(),
        iPad: getMobileOS.isiOS_Tablet(),
        LG: getMobileOS.isLG(),
        OperaMini: getMobileOS.isOpera(),
        IEMobile: getMobileOS.isWindows(),
        UnrecognizedMobile: getMobileOS.isUnrecognizedTablet(),
        UnrecognizedTablet: getMobileOS.isUnrecognizedMobile()
    };
    var activeDevice = Object.keys(deviceHash).filter(function (key) { return deviceHash[key]; });
    if (activeDevice.length < 1) {
        return false;
    }
    return activeDevice[0];
};
exports.isDeviceMobile = function () {
    return getMobileOS.any();
};
exports.detectIeVersion = function () {
    var ua = exports.getNavigator().userAgent;
    // Test values
    // IE 10
    // ua = 'Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0)';
    // IE 11
    // ua = 'Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko';
    // Edge 13
    // ua = 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko)
    // Chrome/46.0.2486.0 Safari/537.36 Edge/13.10586';
    var msie = ua.indexOf('MSIE ');
    if (msie > 0) {
        // IE 10 or older => return version number
        return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
    }
    var trident = ua.indexOf('Trident/');
    if (trident > 0) {
        // IE 11 => return version number
        var rv = ua.indexOf('rv:');
        return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
    }
    var edge = ua.indexOf('Edge/');
    if (edge > 0) {
        // Edge (IE 12+) => return version number
        return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
    }
    // other browsers
    return -1;
};
/**
 * Checks to see if a style feature is supported.
 * source: https://stackoverflow.com/a/11047247
 */
exports.supportsCSSStyle = function (cssStyle, enableWebkit) {
    if (enableWebkit === void 0) { enableWebkit = false; }
    var element = document.createElement('div');
    element.style.cssText = "" + (enableWebkit ? '-webkit-' : '') + cssStyle;
    return (element.style.length !== 0) &&
        (document.documentMode === undefined || document.documentMode > 9);
};
/**
 * @description This method will return a query string paramater in a standard web url
 * @param parameter The query parameter you want to search for in string
 * @param url Optional URL that you want to look for parameters in
 * @returns The value of the parameter or null
 * @example gup('fakeName', 'http://example.com/?fakeName=123&drTheme=fake-theme')
 */
exports.gup = function (parameter, url) {
    var name = parameter.replace(/[\[]/, '\\\[').replace(/[\]]/, '\\\]');
    // tslint:disable-next-line: prefer-template
    var results = new RegExp('[?&]' + name + '=?([^&#]*)').exec(url || window.location.href);
    return results == null ? null : results[1] || true;
};
exports.addClassToElement = function (element, cls) {
    // tslint:disable-next-line: prefer-template
    element.className += ' ' + cls;
};
exports.removeClassFromElement = function (element, cls) {
    // tslint:disable-next-line: prefer-template
    element.className = element.className.replace(new RegExp('(^|\\b)' + cls.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
};
exports.setOfferStorage = function (options) {
    var dealerId = options.dealerId, vin = options.vin, connectionId = options.connectionId, offerId = options.offerId, zipCode = options.zipCode, isZipCodeConfirmed = options.isZipCodeConfirmed;
    try {
        if (!dealerId || !vin || !connectionId) {
            throw Error('Missing data to save in local storage');
        }
        var offerStorage = JSON.stringify({ vin: vin, connectionId: connectionId, offerId: offerId, zipCode: zipCode, isZipCodeConfirmed: isZipCodeConfirmed });
        window.localStorage.setItem("drs:" + dealerId + ":" + vin, offerStorage);
    }
    catch (error) {
        console.error('Error setting local storage value', error);
    }
};
exports.readOfferStorage = function (dealerId, vin) {
    try {
        return JSON.parse(window.localStorage.getItem("drs:" + dealerId + ":" + vin));
    }
    catch (error) {
        console.error('Error reading local storage value', error);
    }
};
